var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResetPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#F7A246"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6667 5.33331C9.19391 5.33331 8.00001 6.52722 8.00001 7.99998V9.33331C7.26363 9.33331 6.66667 9.93027 6.66667 10.6666V17.3333C6.66667 18.0697 7.26363 18.6666 8.00001 18.6666H16C16.7364 18.6666 17.3333 18.0697 17.3333 17.3333V10.6666C17.3333 9.93027 16.7364 9.33331 16 9.33331V7.99998C16 6.52722 14.8061 5.33331 13.3333 5.33331H10.6667ZM14.6667 9.33331H9.33334V7.99998C9.33334 7.2636 9.93029 6.66665 10.6667 6.66665H13.3333C14.0697 6.66665 14.6667 7.2636 14.6667 7.99998V9.33331ZM8.00001 12.6666L10.3333 10.3333L11 11L10 12H14.3333C14.8856 12 15.3333 12.4477 15.3333 13V16.3333C15.3333 16.8856 14.8856 17.3333 14.3333 17.3333H9.33334V16H13.6667C13.8508 16 14 15.8507 14 15.6666V13.6666C14 13.4826 13.8508 13.3333 13.6667 13.3333H10L11 14.3333L10.3333 15L8.00001 12.6666Z",
    fill: "#FEFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetPassword);
export default __webpack_public_path__ + "static/media/ResetPassword.fd329ae4de392797d5d589fd333b9f0d.svg";
export { ForwardRef as ReactComponent };